//Action set value
export const REWARDS_SET_VALUE = 'atRetirement/rewardsSolutionsTable/setValue/';

//Action names
export const REWARDS_SOLUTIONS_SET_VALUE = REWARDS_SET_VALUE + 'setConsideration';

//action methods
export const setRewardsSolutionsValue = (value) => ({ type: REWARDS_SOLUTIONS_SET_VALUE, value });
